import React from "react";
import { ProgressBar } from 'react-bootstrap';
import WorkerProcessStatus from "../../models/WorkerProcessStatus";

const ProgressBarControl: React.FC<WorkerProcessStatus> = ({ dateTime, status, message, processId, processName, processType, totalItems, currentItem, progress }) => {

    let width = '100%';

    return (
        <div style={{ width: width, marginTop: 10 }}>
            <ProgressBar animated now={progress} />
            <div>{message}</div>
        </div>
    );
}
export default ProgressBarControl;